import _ from 'lodash';
import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import Attachment from 'models/attachment';
import connect from 'components/lib/connect';
import LoadingSpinner from 'components/lib/loading_spinner';
import Upload from 'models/upload';

export const StyledSlateInlineImage = styled.img`
  cursor: default;
  display: inline-block;
  max-width: 100%;
  ${p => p.isFocused && focusedImage};
`;

const focusedImage = css`
  border: 1px solid ${p => p.theme.colors.green400};
`;

export const StyledSlateInlineImageLoading = styled.div`
  background-color: ${p => p.theme.colors.gray100};
  border: 1px solid ${p => p.theme.colors.green400};
  cursor: default;
  height: 200px;
  max-width: 100%;
  position: relative;
  & .loadingSpinner {
    height: 50px;
    width: 50px;
  }
`;

class SlateInlineImage extends React.Component {
  constructor(props) {
    super(props);
    _.bindAll(this, ['renderCompleted', 'renderLoading', 'renderFailed']);
  }

  renderCompleted() {
    const className = classnames('slate-inlineImage', { 'slate-inlineImage-focused': this.props.isFocused });
    return <StyledSlateInlineImage src={this.props.src} className={className} isFocused={this.props.isFocused} />;
  }

  renderLoading() {
    return (
      <StyledSlateInlineImageLoading className="slate-inlineImage-loading">
        <LoadingSpinner />
      </StyledSlateInlineImageLoading>
    );
  }

  renderFailed() {
    return null;
  }

  render() {
    const attachment = this.props.attachment;
    // !attachment to handle any imported images that are hosted elsewhere
    if (!attachment || attachment instanceof Attachment) {
      return this.renderCompleted();
    }

    switch (attachment.status) {
      case Upload.Status.NEW:
      case Upload.Status.STARTED:
        return this.renderLoading();
      case Upload.Status.FAILED:
        return this.renderFailed();
      case Upload.Status.COMPLETED:
      default:
        return this.renderCompleted();
    }
  }
}

SlateInlineImage.propTypes = {
  attachment: PropTypes.oneOfType([PropTypes.instanceOf(Attachment), PropTypes.instanceOf(Upload)]),
  isFocused: PropTypes.bool,
  src: PropTypes.string,
};

// Container

const mapStateToProps = (context, props) => {
  const { attachmentId } = props;
  const snippetCompositionProvider = context.getProvider('snippetComposition');
  if (attachmentId) {
    const snippet = snippetCompositionProvider.get();
    const attachment = snippet && snippet.findAttachmentById(attachmentId);
    return { ...props, attachment };
  }

  return { ...props };
};

export { SlateInlineImage };
export default connect(mapStateToProps)(SlateInlineImage);



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/composition/lib/slate/slate_inline_image.jsx